import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import { TabsContent } from '@/components/ui/tabs';
import { formatCurrency, formatPercent } from '@/lib/utils/formatters';
import { useGestaoImpostosContext } from '@/contexts';

export function HistoricoTab() {
  const { historico, isLoadingHistorico } = useGestaoImpostosContext();

  return (
    <TabsContent value="historico" className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Histórico Mensal</CardTitle>
          <CardDescription>Evolução da carga tributária nos últimos meses</CardDescription>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Período</TableHead>
                <TableHead className="text-right">Vendas</TableHead>
                <TableHead className="text-right">ICMS</TableHead>
                <TableHead className="text-right">PIS</TableHead>
                <TableHead className="text-right">COFINS</TableHead>
                <TableHead className="text-right">IPI</TableHead>
                <TableHead className="text-right">Total Impostos</TableHead>
                <TableHead className="text-right">% s/ Vendas</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoadingHistorico ? (
                Array.from({ length: 6 }).map((_, i) => (
                  <TableRow key={i}>
                    {Array.from({ length: 8 }).map((__, j) => (
                      <TableCell key={j}>
                        <Skeleton className="h-4 w-full" />
                      </TableCell>
                    ))}
                  </TableRow>
                ))
              ) : historico.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} className="text-center text-muted-foreground py-8">
                    Nenhum mês com movimento encontrado para esta empresa.
                  </TableCell>
                </TableRow>
              ) : (
                historico.map(mes => (
                  <TableRow key={mes.mesReferencia}>
                    <TableCell className="font-medium">{mes.label}</TableCell>
                    <TableCell className="text-right">{formatCurrency(mes.totalVendas)}</TableCell>
                    <TableCell className="text-right">{formatCurrency(mes.icms)}</TableCell>
                    <TableCell className="text-right">{formatCurrency(mes.pis)}</TableCell>
                    <TableCell className="text-right">{formatCurrency(mes.cofins)}</TableCell>
                    <TableCell className="text-right">{formatCurrency(mes.ipi)}</TableCell>
                    <TableCell className="text-right font-semibold text-red-600">
                      {formatCurrency(mes.totalImpostos)}
                    </TableCell>
                    <TableCell className="text-right">
                      {formatPercent(mes.percentualSobreVendas)}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </TabsContent>
  );
}
